<script setup>
import { ref } from 'vue';

const props = defineProps({
    question: {
        type: Object,
        required: true,
    },
});
const value = defineModel({ type: [Object], required: true });
const elements = ref([]);
for (let i = props.question.options.min; i <= props.question.options.max; i++) {
    elements.value.push({
        value: i,
    });
}
</script>

<template>
    <div class="flex justify-center items-end gap-4">
        <div class="max-w-64 text-gray-600">
            {{ question.options.min_text }}
        </div>
        <div class="flex justify-center gap-2">
            <div v-for="element in elements" :key="element.value">
                <label for="">
                    <div>{{ element.value }}</div>
                    <div>
                        <input
                            :name="`question_${question.id}`"
                            :required="question.is_required"
                            :id="`display_option_${element.value}`"
                            :value="element.value"
                            v-model="value.choice"
                            type="radio"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        />
                    </div>
                </label>
            </div>
        </div>
        <div class="max-w-64 text-gray-600">
            {{ question.options.max_text }}
        </div>
    </div>
</template>
